'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RichMediaIFrameContent = require('./RichMediaIFrameContent');

var _RichMediaIFrameContent2 = _interopRequireDefault(_RichMediaIFrameContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RichMediaContent = function RichMediaContent(props) {
    var show = props.show;

    if (!show) return null;

    return _react2.default.createElement(_RichMediaIFrameContent2.default, props);
};

// Components
// Lib


RichMediaContent.propTypes = {
    show: _propTypes2.default.bool
};

exports.default = RichMediaContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMediaContent.js
// module id = 2009
// module chunks = 0